import { render, staticRenderFns } from "./ObserveResize.vue?vue&type=template&id=bc0a1718&"
import script from "./ObserveResize.vue?vue&type=script&lang=js&"
export * from "./ObserveResize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports